(() => {
  if (window.dataLayer[0].adFreeReasons.PaidUser === 1 && window.provider === 'gpt') {
    window.park.googlePublisherTag.loadAndInit();
  } else if (window.provider === 'stroeer') {
    const ssoCookie = window.park.cookie.get('sso');
    if (ssoCookie) {
      let ssoCookieString = ssoCookie.substring(1, ssoCookie.length - 1);
      ssoCookieString = atob(ssoCookieString);
      const ssoCookieObject = JSON.parse(ssoCookieString);
      if (ssoCookieObject && ssoCookieObject.paidtime && ssoCookieObject.paidtime === 1) {
        document.addEventListener('DOMContentLoaded', () => {
          function loadMetaTag() {
            const metaTagScript = document.createElement('script');
            metaTagScript.type = 'text/javascript';
            metaTagScript.onload = () => {
              window.park.stroeer.init();
            };
            metaTagScript.src = 'https://cdn.stroeerdigitalgroup.de/metatag/live/OMS_wz.de/metaTag.min.js';
            document.getElementsByTagName('head')[0].appendChild(metaTagScript);
          }

          const otsdkScript = document.createElement('script');
          otsdkScript.type = 'text/javascript';
          otsdkScript.src = 'https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js';
          otsdkScript.setAttribute('data-domain-script', window.dataDomainScript);
          otsdkScript.onload = () => {
            function waitForSdk() {
              // eslint-disable-next-line
              if (!!window.OneTrust && !!window.__tcfapi && !!window.Optanon) {
                window.Optanon.RejectAll();
                loadMetaTag();
              } else {
                setTimeout(waitForSdk, 100);
              }
            }

            waitForSdk();
          };

          // eslint-disable-next-line
          if (window.__tcfapi && document.cookie.indexOf('eupubconsent-v2') >= 0) {
            loadMetaTag();
          } else {
            document.getElementsByTagName('head')[0].appendChild(otsdkScript);
          }
        });
      }
    }
  }
})();



// WEBPACK FOOTER //
// ./src/widgets/consent/paid-user.js